import { ROLES } from '@/lib/constants/app.constants';

/** Roles allowed by backend `GET /inspections/:id/pdf`. */
export const INSPECTION_PDF_ELIGIBLE_ROLE_IDS: readonly string[] = [
  ROLES.REVIEWER,
  ROLES.PLANNER,
  ROLES.REGIONAL_DIRECTOR,
  ROLES.ANALYST,
  ROLES.DECISION_EDITOR,
  ROLES.CUSTOMER,
  ROLES.BOOKING_REQUESTOR,
  ROLES.TECHNICIAN,
];

export function hasInspectionPdfEligibleRole(userRoles: string[] | undefined): boolean {
  if (!userRoles || userRoles.length === 0) {
    return false;
  }
  return INSPECTION_PDF_ELIGIBLE_ROLE_IDS.some((roleId) => userRoles.includes(roleId));
}
